export const defaultJson = [
  {
    stepId: 'Company Details',
    stepName: 'Basic Details',
    showStepName: false,
    stepVisible: true,
    stepPosition: 0,
    stepType: 'form',
    sections: [
      {
        apiKeyId: 'application',
        sectionId: 'CompanyDetails1',
        sectionName: 'Basic Details',
        subSectionName: '',
        sectionPosition: 1,
        sectionVisible: true,
        sectionHelp: 'Fields marked with * are required',
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[Startup_Name__c]',
            required: true,
            name: 'application[Startup_Name__c]',
            label: 'Name of Startup',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
            ui: {
              gridType: 'fullRow',
            },
          },

          {
            fieldId: 'application[Company_Synopsis__c]',
            required: true,
            name: 'application[Company_Synopsis__c]',
            label: 'Company Sypnosis',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 250,
                message: 'This field cannot be more than 250 characters',
              },
            },
            ui: {
              gridType: 'fullRow',
            },
          },
          {
            name: 'application',
            type: 'address',
            options: [
              {
                fieldId: 'Country__c',
                required: true,
                name: 'Country__c',
                label: 'Country',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'State__c',
                required: true,
                name: 'State__c',
                label: 'State',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'Base_City__c',
                required: true,
                name: 'Base_City__c',
                label: 'City',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
              },
            ],
          },

          {
            fieldId: 'application[Launch_Year__c]',
            required: true,
            name: 'application[Launch_Year__c]',
            label: 'Founded year',
            type: 'date',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a valid value',
              },
            },
          },
          {
            fieldId: 'application[Startup_Website_Url__c]',
            required: true,
            name: 'application[Startup_Website_Url__c]',
            label: 'Company Website',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
              pattern: {
                value: '',
                message: 'Please input a valid value',
              },
            },
          },
          {
            fieldId: 'application[Sector_Industry__c]',
            required: true,
            name: 'application[Sector_Industry__c]',
            label: 'Sector',
            type: 'select',
            options: [
              {
                label: 'Aerospace, Defence & SpaceTech',
                value: 'Aerospace, Defence & SpaceTech',
              },
              {
                label: 'Agriculture & FoodTech',
                value: 'Agriculture & FoodTech',
              },
              { label: 'AI, ML & IoT', value: 'AI, ML & IoT' },
              {
                label: 'Art, Culture & Architecture',
                value: 'Art, Culture & Architecture',
              },
              {
                label: 'Automotive, EV & Smart Mobility',
                value: 'Automotive, EV & Smart Mobility',
              },
              { label: 'Blue Economy', value: 'Blue Economy' },
              { label: 'Chemicals & BioTech', value: 'Chemicals & BioTech' },
              { label: 'Circular Economy', value: 'Circular Economy' },
              {
                label: 'ClimateTech & Clean Energy',
                value: 'ClimateTech & Clean Energy',
              },
              {
                label: 'Data Mining & Analytics',
                value: 'Data Mining & Analytics',
              },
              { label: 'EdTech', value: 'EdTech' },
              { label: 'FemTech', value: 'FemTech' },
              { label: 'FinTech & InsurTech', value: 'FinTech & InsurTech' },
              {
                label: 'Healthcare & Life Sciences',
                value: 'Healthcare & Life Sciences',
              },
              {
                label: 'HRTech & Smart Workforce',
                value: 'HRTech & Smart Workforce',
              },
              {
                label: 'Industry 4.0 & Advanced Manufacturing',
                value: 'Industry 4.0 & Advanced Manufacturing',
              },
              {
                label: 'Lifestyle, Personalcare & D2C',
                value: 'Lifestyle, Personalcare & D2C',
              },
              { label: 'MarketingTech & MICE', value: 'MarketingTech & MICE' },
              {
                label: 'Media & Entertainment',
                value: 'Media & Entertainment',
              },
              {
                label: 'PropTech, LegalTech & RegTech',
                value: 'PropTech, LegalTech & RegTech',
              },
              { label: 'RetailTech', value: 'RetailTech' },
              {
                label: 'SaaS, Software & IT/ITES',
                value: 'SaaS, Software & IT/ITES',
              },
              {
                label: 'Smart Cities & E-Governance',
                value: 'Smart Cities & E-Governance',
              },
              {
                label: 'Social Impact, Rural Livelihood & Sustainability',
                value: 'Social Impact, Rural Livelihood & Sustainability',
              },
              { label: 'Sports Tech & Gaming', value: 'Sports Tech & Gaming' },
              {
                label: 'Supply Chain & Logistics',
                value: 'Supply Chain & Logistics',
              },
              {
                label: 'Telecom, Networking & Hardware',
                value: 'Telecom, Networking & Hardware',
              },
              {
                label: 'TextileTech & Fashion',
                value: 'TextileTech & Fashion',
              },
              { label: 'Travel & Tourism', value: 'Travel & Tourism' },
              {
                label: 'Web 3.0, Blockchain, VR/AR',
                value: 'Web 3.0, Blockchain, VR/AR',
              },
              { label: 'Other', value: 'Other' },
            ],
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a valid value',
              },
            },
          },
          {
            fieldId: 'application[Currency_Type__c]',
            required: true,
            name: 'application[Currency_Type__c]',
            label: 'Funding Ask Currency',
            type: 'select',
            options: [
              { label: 'USD', value: 'USD' },
              { label: 'INR', value: 'INR' },
              { label: 'AED', value: 'AED' },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'application[Funding_Ask__c]',
            required: true,
            name: 'application[Funding_Ask__c]',
            label: 'Funding Ask',
            type: 'input',
            validationType: 'number',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a valid value',
              },
            },
          },
        ],
      },
    ],
  },
  {
    stepId: 'Company Details',
    stepName: 'Founding Team Details',
    showStepName: false,
    stepVisible: true,
    stepPosition: 0,
    stepType: 'form',
    sections: [
      {
        sectionId: 'employmentDetails',
        sectionName: 'Founding Team Members',
        subSectionName: '',
        sectionPosition: 3,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'teamMembers',
            name: 'teamMembers',
            label: 'Team Members',
            type: 'array',
            metaData: {
              addMultiple: true,
              minItems: 1,
            },
            fieldsArray: [
              {
                fieldId: 'FirstName',
                required: true,
                name: 'FirstName',
                label: 'First Name',
                type: 'input',
                validationType: 'alpha',
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 80,
                    message: 'This field cannot be more than 80 characters',
                  },
                  pattern: {
                    value: '',
                    message: 'Please input a valid value',
                  },
                },
              },
              {
                fieldId: 'LastName',
                required: true,
                name: 'LastName',
                label: 'Last Name',
                type: 'input',
                validationType: 'alpha',
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 80,
                    message: 'This field cannot be more than 80 characters',
                  },
                  pattern: {
                    value: '',
                    message: 'Please input a valid value',
                  },
                },
              },
              {
                fieldId: 'Linkedin_Profile_URL__c',
                required: true,
                name: 'Linkedin_Profile_URL__c',
                label: 'LinkedIn Profile URL',
                type: 'input',
                validationType: 'alphaNumeric',
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 80,
                    message: 'This field cannot be more than 80 characters',
                  },
                  pattern: {
                    value: '',
                    message: 'Please input a valid value',
                  },
                },
              },
            ],
          },
        ],
      },
    ],
  },

  {
    stepId: 'additionalQuestions',
    stepName: 'Pitch Deck',
    showStepName: false,
    stepVisible: true,
    stepPosition: 1,
    stepType: 'documentUpload',
    sections: [],
  },

  {
    stepId: 'summaryWithDeclaration',
    stepName: 'Summary',
    stepPosition: 5,
    showStepName: true,
    stepVisible: true,
    stepType: 'summary',
    voucher: true,
    sections: [],
  },
];
